import {MessageLevel, MessageVO,} from '@models/index';
import {FormGroup,} from '@angular/forms';

/**
 * 発生したメッセージをため込む。
 * errorに限らず、warningやinfo系のメッセージも取り扱う。
 */
export class MessageStackService {
  messages: Array<MessageVO> = new Array<MessageVO>();
  messageLevel: MessageLevel;
  // エラーを表示するフォームグループ
  formGroups: FormGroup[] = new Array<FormGroup>();

  /**
   * コンストラクタ.
   * @param messageLevel メッセージレベル
   */
  constructor(messageLevel: MessageLevel) {
    this.messageLevel = messageLevel;
  }

  /**
   * [一般開発者利用可]
   * Stackにエラーを追加する.
   * @param {MessageVO} message メッセージ情報(MessageVO型)
   * @return メッセージの登録有無
   */
  add(message: MessageVO): boolean {
    if (message?.messageId || message?.message) {
      this.messages.push(message);
    }
    return this.hasMessage();
  }

  /**
   * [一般開発者利用可]
   * メッセージリストを全て追加する.
   * @param messages メッセージ情報リスト(MessageVO型配列)
   * @return メッセージの登録有無
   */
  addAll(messages: Array<MessageVO>): boolean {
    if(messages) {
      for(const message of messages) {
        this.add(message);
      }
    }
    return this.hasMessage();
  }

  /**
   * [一般開発者利用可]
   * Stackされているメッセージをクリアする.
   */
  clear(): void {
    this.messages = new Array<MessageVO>();
  }

  /**
   * [一般開発者利用可]
   * Stackに登録されているメッセージ数
   */
  length(): number {
    return this.messages.length;
  }

  /**
   * [一般開発者利用可]
   * Stackに登録されているメッセージが存在するか
   * @return メッセージの存在有無
   */
  hasMessage(): boolean {
    return this.messages.length !== 0;
  }

  /**
   * [一般開発者利用可]
   * フォームにエラーがあることを画面に提示したいとき提示対象のフォームをセットする。
   * APIコールにてサーバーサイドからエラーが返ってくるとitem pathから
   * 当MessageStackをスローした際に、スタックされているメッセージの
   * itemPathとフォームのキーを照合してエラー状態にする。
   * @param form エラーを表示したいフォーム
   */
  setFormGroupsForError(form: FormGroup[]): void {
    this.formGroups = form;
  }

  /**
   * [一般開発者利用可]
   * 拡張エラーコードの配列を返却する。
   * メッセージに拡張エラーコードが含まれていない場合は、要素数0の配列が返却される。
   * @return 拡張エラーコード
   */
   getExtraErrorCode(): string[] {
     const extraErrorCodes: string[] = [];
     this.messages.forEach((value) => {
       if(value.extraErrorCode) {
         extraErrorCodes.push(value.extraErrorCode);
       }
     });
     return extraErrorCodes;
   }

   /**
   * [一般開発者利用可]
   * 拡張エラーコードが設定されているかどうかを判定する。
   * @return 拡張エラーコードの設定有無
   */
   hasExtraErrorCode(extraErrorCode: string): boolean {
     let isCode = false;
     this.messages.forEach((value) => {
       if(value.extraErrorCode === extraErrorCode) {
         isCode = true;
       }
     });
     return isCode;
   }
}
